/**
 * 用户AI交易配置类型定义
 */

// AI交易模式枚举
export enum AiTradeMode {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL'
}

export const AiTradeModeMap: Record<AiTradeMode, string> = {
    [AiTradeMode.AUTO]: '自动',
    [AiTradeMode.MANUAL]: '手动'
};

// 风控模式枚举
export enum RiskMode {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
    AI = 'AI'
}

export const RiskModeMap: Record<RiskMode, string> = {
    [RiskMode.AUTO]: '自动模式',
    [RiskMode.MANUAL]: '手动模式',
    [RiskMode.AI]: 'AI模式'
};

// 交易类型枚举
export enum TradeType {
    SIMULATION = 'SIMULATION',
    REAL = 'REAL'
}

export const TradeTypeMap: Record<TradeType, { label: string; emoji: string; description: string }> = {
    [TradeType.SIMULATION]: {
        label: '模拟盘',
        emoji: '🎮',
        description: '使用模拟资金进行交易，无真实资金风险，适合策略验证和熟悉系统'
    },
    [TradeType.REAL]: {
        label: '实盘',
        emoji: '💰',
        description: '使用真实资金进行交易，请确保已充分了解风险并做好资金管理'
    }
};

// 交易风格枚举
export enum TradingStyle {
    C1_CONSERVATIVE = 'C1_CONSERVATIVE',
    C2_CAUTIOUS = 'C2_CAUTIOUS',
    C3_MODERATE = 'C3_MODERATE',
    C4_ACTIVE = 'C4_ACTIVE',
    C5_AGGRESSIVE = 'C5_AGGRESSIVE'
}

export interface TradingStyleInfo {
    style: TradingStyle;
    label: string;
    emoji: string;
    description: string;
    maxLossRate: number;
    targetProfitRate: number;
}

export const TradingStyleMap: Record<TradingStyle, TradingStyleInfo> = {
    [TradingStyle.C1_CONSERVATIVE]: {
        style: TradingStyle.C1_CONSERVATIVE,
        label: '保守型',
        emoji: '🛡️',
        description: '优先考虑资本保护，只在确定性极高时交易，严格控制止损',
        maxLossRate: 0.03,
        targetProfitRate: 0.05
    },
    [TradingStyle.C2_CAUTIOUS]: {
        style: TradingStyle.C2_CAUTIOUS,
        label: '谨慎型',
        emoji: '⚖️',
        description: '注重风险控制，选择性参与高确定性机会',
        maxLossRate: 0.05,
        targetProfitRate: 0.10
    },
    [TradingStyle.C3_MODERATE]: {
        style: TradingStyle.C3_MODERATE,
        label: '稳健型',
        emoji: '📊',
        description: '平衡风险与收益，寻找稳健的交易机会',
        maxLossRate: 0.08,
        targetProfitRate: 0.15
    },
    [TradingStyle.C4_ACTIVE]: {
        style: TradingStyle.C4_ACTIVE,
        label: '积极型',
        emoji: '⚡',
        description: '追求更高收益，愿意承担适度风险，对市场波动反应更灵敏',
        maxLossRate: 0.12,
        targetProfitRate: 0.20
    },
    [TradingStyle.C5_AGGRESSIVE]: {
        style: TradingStyle.C5_AGGRESSIVE,
        label: '激进型',
        emoji: '🚀',
        description: '追求高收益机会，承担较高风险以获取更大回报',
        maxLossRate: 0.18,
        targetProfitRate: 0.30
    }
};

// 有效的频次选项
export const VALID_FREQUENCIES = [5, 10, 15, 20, 30];

// 用户AI交易配置接口
export interface UserAiTradeConfig {
    configId: number;
    userId: number;
    aiTradeMode: AiTradeMode;
    aiTradeFrequency: number;
    riskMode: RiskMode;
    tradingStyle: TradingStyle;
    tradeType: TradeType;
    maxParallelCapital: number | null;
    agentConfigId?: number | null;
    promptUserSetting?: string | null;
    createTime: string;
    updateTime: string;
}

export interface PromptSettingRequest {
    userSetting: string | null;
}

export interface PromptSettingResponse {
    userSetting: string | null;
    defaultUserSetting: string;
    effectiveUserSetting: string;
    isDefault: boolean;
}

// 更新配置请求接口
export interface UpdateConfigRequest {
    aiTradeMode?: AiTradeMode;
    aiTradeFrequency?: number;
    riskMode?: RiskMode;
    tradingStyle?: TradingStyle;
    tradeType?: TradeType;
    maxParallelCapital?: number | null;
}
